import React, {useEffect, useState} from "react";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {Icon28TargetOutline} from "@vkontakte/icons";
import {fetchActiveMissions} from "../../services/missions";

const READY_BADGE_CLASSES = "absolute top-2 right-2 inline-flex min-w-[22px] h-5 items-center justify-center px-1 rounded-full text-[11px] font-semibold bg-yellow-400 text-yellow-900 border border-yellow-500";

// Баннер с краткой информацией, чтобы перейти на отдельную панель миссий.
export default function MissionsBanner() {
    const routeNavigator = useRouteNavigator();
    const handleClick = () => routeNavigator.push('/missions');
    // Храним количество миссий с готовой наградой, чтобы отобразить бейдж.
    const [claimableCount, setClaimableCount] = useState(0);

    useEffect(() => {
        // Загружаем статус миссий для отображения количества наград на главной.
        fetchActiveMissions()
            .then(resp => {
                const payload = resp.data?.response || {daily: [], weekly: []};
                const allMissions = [...(payload.daily || []), ...(payload.weekly || [])];
                const readyCount = allMissions.filter(mission => mission.status === "completed").length;
                setClaimableCount(readyCount);
            })
            .catch(err => {
                console.error("missions banner load error", err);
                setClaimableCount(0);
            });
    }, []);

    return (
        <div className="w-full cursor-pointer" onClick={handleClick}>
            <div className="bg-gray-800 rounded-xl shadow-md p-4 space-y-4 hover:shadow-lg transition-shadow duration-200 relative">
                <div className="flex items-center justify-between gap-3">
                    <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-yellow-400 text-yellow-800 flex items-center justify-center">
                        <Icon28TargetOutline/>
                    </div>
                    <div className={"text-gray-400 flex-1"}>
                        <p className="text-base font-semibold">Missions</p>
                        <p className="text-sm">Track progress for daily and weekly goals</p>
                    </div>
                    {claimableCount > 0 && (
                        <span className={READY_BADGE_CLASSES}>{claimableCount}</span>
                    )}
                </div>
            </div>
        </div>
    );
}
